import { useSelectedPlace } from "../../hooks/place/useSelectedPlace";
import { useAuth } from "../../hooks/useAuth";

export default function PlaceSwitcher() {
  const { user, isAdmin } = useAuth();
  const { selectedPlace, availablePlaces, setSelectedPlaceId } =
    useSelectedPlace(user, isAdmin);

  // Don't show if user is a Super Admin or only has 1 place
  if (user?.role?.label === "ADMIN" || availablePlaces.length <= 1) {
    return null;
  }

  return (
    <div className="d-flex align-items-center ms-3 w-100 mx-auto">
      {/* <label className="me-2 text-muted small">Managing:</label> */}
      <select
        className="form-select form-select-md w-100"
        value={selectedPlace?.id}
        onChange={(e) => setSelectedPlaceId(e.target.value)}
        style={{ maxWidth: "300px" }}
      >
        {availablePlaces.map((place) => (
          <option key={place.id} value={place.id}>
            {place.name}
          </option>
        ))}
      </select>
    </div>
  );
}
